export const projects = [
    {
        storeId: 'charlieAI',
        storeName:"Charlie AI",
        desc: "At Charlie, built AI-driven sales automation systems including CRM integrations, custom knowledge bases, and an Autobooking flow that auto-schedules meetings from calendars. Designed intelligent flows (Talk-Later, Hunts, Vets) using LangGraph and LLMs to optimize lead engagement, follow-ups, and disqualification for efficiency and reliability.",
    },
    {
        storeId: 'mara',
        storeName:"MARA",
        desc: "At MARA, built AI-powered hotel reputation management and automation solutions, including intelligent review response workflows, sentiment analytics, and centralized review management",
    },
    {
        storeId: 'carbonlink',
        storeName:"Carbonlink (Decarbonization Platform)",
        desc: "Architected a decarbonization platform enabling seamless carbon credit management with advanced AI, blockchain, and serverless technologies, achieving significant performance improvements, secure transactions, and scalable infrastructure.",
    },
    {
        storeId: 'rivian',
        storeName:"Rivian (Automotive Industry)",
        desc: "Developed the Launchpad OT (LOT) application to enrich Delmia BoP with AI-powered insights and work instructions for EV manufacturing, leveraging AWS serverless architecture, LangChain, and vector embeddings to enhance efficiency, scalability, and data synchronization.",
    },
    {
        storeId: 'pickle',
        storeName:"Pickle (Marketing Agency)",
        desc: "Developed a dynamic social media insights platform using Next.js, TypeScript, and AI-driven analytics, enabling real-time metrics, sentiment analysis, and advanced creator search with LangChain and vector embeddings, while ensuring data privacy and automation with OAuth, Inngest, and secure integrations.",
    },
    {
        storeId: 'insage',
        storeName:"Insage AI (Analytics Dashboards)",
        desc: "Developed InsageAI, an advanced AI-powered platform using Next.js, AWS, and Mage AI, enabling automated data analysis, personalized insights, and custom visualizations to enhance productivity and streamline data management.",
    },
    {
        storeId: 'gridware',
        storeName:"Gridware (Electric Grids Automation)",
        desc: "Designed and implemented scalable distributed systems for real-time IoT grid monitoring, developed data pipelines and APIs, and built customer-facing features using React and TypeScript, leveraging AWS, Kafka, and observability tools to enhance performance and reliability.",
    },
    {
        storeId: 'rms',
        storeName:"RMS (Resource Management System)",
        desc: "Led the development of a scalable employee management system and resource management solution for global fintech call centers, leveraging Next.js, React, Redux, and microservices. Improved UI design implementation, internationalization, security, and operational efficiency across key modules.",
    },
    {
        storeId: 'ivr',
        storeName:"IVR (Interactive Voice Recording)",
        desc: "Developed a scalable IVR application using React, Next.js, Spring Boot, Kubernetes, and AWS, optimizing performance, data integrity, and deployment efficiency through microservices, observability tools, and environment-specific configurations.",
    },
    {
        storeId: 'ch3',
        storeName:"Cardholder (Banking App)",
        desc: "Led the development of a unified fintech application using Spring Boot and JavaScript, enhancing security, performance, and customization, resulting in a 30% reduction in security incidents, 35% improvement in response time, and a 40% increase in client satisfaction.",
    },
    {
        storeId: 'cms',
        storeName:"Content Management System",
        desc: "Led the development and maintenance of SaaS banking applications, mentoring junior developers, managing migrations for over 100 client websites, and utilizing JavaScript, HTML/CSS, AWS Lambda, and REST APIs to enhance functionality and user experience.",
    },
    {
        storeId: 'petaid',
        storeName:"Pet Aid",
        desc: "Led the development of a scalable platform for veterinarians and pet owners using React, Next.js, and Node.js, integrating features like Amazon Chime for video calls and i18n for global access, resulting in improved user engagement and reduced in-person appointments.",
    },
    {
        storeId: 'lnmngr',
        storeName:"Linkedin Manager (Chrome extension)",
        desc: "Developed a Chrome extension for recruiters using React, TypeScript, Redux, and AWS, improving job and candidate management efficiency by 30% and reducing recruiter workload by 32% through AI-driven automation and innovative features.",
    },
    {
        storeId: 'netsuite',
        storeName:"Oracle Netsuite (Suitescript)",
        desc: "Designed and implemented saved searches and custom scripts to optimize inventory tracking, automate workflows, and enhance sales efficiency, aligning with business needs.",
    },
];


export const skillsSection = {
    title: "What I do",
    subTitle:
        "AI-Driven Full-Stack Developer with 6+ years of expertise across modern technologies, specializing in AI/ML integrations.",
    skills: [
        {
            heading: "⚡ Artificial Intelligence & Machine Learning:",
            description: "Large Language Models (LLMs), Langgraph, Agentic AI, Vector Embeddings, SageMaker, Bedrock, OpenAI, Claude Code"
        },
        {
            heading: "⚡ Cloud & DevOps:",
            description: "AWS (S3, EC2, EKS, Gateway, CloudFront, Amplify, CDK, Serverless), Azure, GCP, Docker, Kubernetes, Istio Service Mesh, CI/CD Pipelines, Queues"
        },
        {
            heading: "⚡ Backend Development:",
            description: "Python (Flask, Django), Node.js (Express.js, Nest.js), Java (Spring Boot), MySQL, PostgreSQL, MongoDB, Supabase, Redis, Firebase, Snowflake, OpenSearch, Prisma, Microservices, Distributed Systems, Event-Driven Architectures, OAuth2, Keycloak, JWT , Pytest"
        },
        {
            heading: "⚡ Frontend Development:",
            description: "JavaScript, TypeScript, React.js, Next.js, Angular, Redux, Zustand, Storybook, Bootstrap, TailwindCSS, Figma, TDD, Jest, Cypress, Puppeteer, Selenium"
        },
        {
            heading: "⚡ Data & Analytics:",
            description: "Airflow, Hadoop, Apache Flink, Apache Spark, Tableau, PowerBI, Snowflake"
        },
        {
            heading: "⚡ Web3 & Blockchain:",
            description: "Fireblocks, Web3.js, Smart Contracts, Decentralized Applications (DApps)"
        },
        {
            heading: "⚡ Observability & Monitoring:",
            description: "Sentry, Datadog, New Relic , Jaeger, Prometheus, Grafana, CloudWatch, ELK Stack"
        },
        {
            heading: "⚡ Other Technical Expertise:",
            description: "Chrome Extensions, Serverless Computing, Stripe, Netsuite, OpenAPI, Jira, VercelAI, GitHub, GitLab, Bitbucket"
        },
    ],

    softwareSkills: [
        {
            skillName: "html-5",
            fontAwesomeClassname: "vscode-icons:file-type-html",
        },
        {
            skillName: "css3",
            fontAwesomeClassname: "vscode-icons:file-type-css",
        },
        {
            skillName: "sass",
            fontAwesomeClassname: "logos:sass",
        },
        {
            skillName: "JavaScript",
            fontAwesomeClassname: "logos:javascript",
        },
        {
            skillName: "TypeScript",
            fontAwesomeClassname: "logos:typescript-icon",
        },
        {
            skillName: "reactjs",
            fontAwesomeClassname: "vscode-icons:file-type-reactjs",
        },
        {
            skillName: "nodejs",
            fontAwesomeClassname: "logos:nodejs-icon",
        },
        {
            skillName: "flutter",
            fontAwesomeClassname: "logos:flutter",
        },
        {
            skillName: "swift",
            fontAwesomeClassname: "vscode-icons:file-type-swift",
        },
        {
            skillName: "npm",
            fontAwesomeClassname: "vscode-icons:file-type-npm",
        },
        {
            skillName: "sql-database",
            fontAwesomeClassname: "vscode-icons:file-type-sql",
        },
        {
            skillName: "mongoDB",
            fontAwesomeClassname: "vscode-icons:file-type-mongo",
        },
        {
            skillName: "aws",
            fontAwesomeClassname: "logos:aws",
        },
        {
            skillName: "firebase",
            fontAwesomeClassname: "logos:firebase",
        },
        {
            skillName: "python",
            fontAwesomeClassname: "logos:python",
        },
        {
            skillName: "git",
            fontAwesomeClassname: "logos:git-icon",
        },
        {
            skillName: "docker",
            fontAwesomeClassname: "logos:docker-icon",
        },
    ],
};
